const urlParam = getAllUrlParams()
export { urlParam }
const helper = {
	clienttype: function() {
		if (urlParam.e) {
			return true
		}
		return false
	}
}
function getAllUrlParams() {
	var url = window.location.href
	// get query string from url (optional) or window
	var queryString = url ? url.split('?')[1] : window.location.search.slice(1)

	// we'll store the parameters here
	var obj = {}

	// if query string exists
	if (queryString) {
		queryString = queryString.split('#')[0]
		var arr = queryString.split('&')
		for (var i = 0; i < arr.length; i++) {
			var a = arr[i].split('=')
			var paramNum
			var paramName = a[0].replace(/\[\d*\]/, function(v) {
				paramNum = v.slice(1, -1)
				return ''
			})
			var paramValue = typeof a[1] === 'undefined' ? true : a[1]
			if (obj[paramName]) {
				// convert value to array (if still string)
				if (typeof obj[paramName] === 'string') {
					obj[paramName] = [ obj[paramName] ]
				}
				if (typeof paramNum === 'undefined') {
					obj[paramName].push(paramValue)
				} else {
					obj[paramName][paramNum] = paramValue
				}
			} else {
				obj[paramName] = paramValue
			}
		}
	}
	return obj
}

export { helper }

export const arrayutility = {
	singleArray(arr) {
		var returnarray = []
		for (var i = 0; i < arr.length; i++) {
			var singleObject = arr[i]
			var obj = {}
			for (var key in singleObject) {
				obj[key] = singleObject[key]
			}
			returnarray[i] = obj
		}
		return returnarray
	},
	returnSingleObject(arr, objkey, value) {
		var arrayValue = []
		arrayValue = this.singleArray(arr)
		var found = false
		var tabIndex
		var returnObj = {}
		for (var i = 0; i < arrayValue.length; i++) {
			var singleObject = {}
			singleObject = arrayValue[i]
			if (singleObject[objkey] == value) {
				found = true
				tabIndex = i
				returnObj = singleObject
				break
				if (found) {
					return returnObj
				}
			}
		}
		return returnObj
	}
}



// WEBPACK FOOTER //
// ./src/helper/index.js